import {IntermediatePart} from "../../intermediatePart";

export default class Furniture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "furniture";
    this.translateId = "furniture";
    this.translateId = "visualizer.fireplace.furniture";

    this.partName = "Furniture";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

}
